import React from "react";
import { createPortal } from "react-dom";
import Button from "../Button";

export const Modal = ({className, title, show, close, children, footer, size}) => {
    // Renderiza o modal via portal no <body>, fora do #panel. Assim o overlay
    // `position: fixed` fica sempre acima do conteúdo da página — inclusive de
    // elementos `position: sticky`/`relative` com z-index (ex.: cabeçalhos de
    // tabela, labels), que no Safari vazam por cima de overlays fixed quando
    // compartilham o mesmo stacking context. Como alguns modais são montados
    // dentro do Sidebar/#panel (ex.: "Meus dados"), o portal é a garantia
    // cross-browser. Combina com `#panel { isolation: isolate }`.
    return createPortal(
        <div className={`modal ${show === true ? 'show' : 'hide'} ${className ? className : ''}`}>
            <div className={`content  ${size ?  size : 'regular'}`}>
                <div className="header">
                    <span>{title}</span>
                    <Button type="transparent" svg={`close`} action={() => close()}/>
                </div>
                <div className={`body`}>
                    {children}
                </div>
                {footer &&
                    <div className="footer">
                        {footer}
                    </div>
                }
            </div>
        </div>,
        document.body
    );
}

export default Modal;